<template>
	<BaseLayout background-color-class="bg-color-white" :content-full-height="true">
		<template #header>
			<HeaderBasic classes="bg-color-white">
				<p class="ml-300 mt-0 delta">Reset your password</p>
			</HeaderBasic>
		</template>

		<div class="container">
			<div class="grid-md gutters-300-md">
				<div class="col-8-md col-offset-2-md">
					<router-view v-slot="{ Component }">
						<TransitionSubpage>
							<component :is="Component" />
						</TransitionSubpage>
					</router-view>
				</div>
			</div>
		</div>
	</BaseLayout>
</template>

<script setup lang="ts">
import HeaderBasic from '@components/header/header-basic.vue';
import TransitionSubpage from '@components/layout/transition-subpage.vue';
import { useHead } from '@unhead/vue';

function setup(): void {
	useHead({
		title: 'Reset Password',
		meta: [{ property: 'og:title', content: 'Reset password' }]
	});
}
setup();
</script>
